import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { Toaster } from 'react-hot-toast';
import { createClient } from 'graphql-ws';

import Header from './layout/header';
import SideBar from './layout/sideBar';
import Home from './pages/home';
import Games from './pages/games';
import Quiz from './games/quiz';
import { useEffect } from 'react';
import Login from './pages/login';
import { AuthProvider, useAuth } from './utils/context';
import Signup from './pages/signup';
import Presentation from './pages/presentation';
import { AlertContainer } from './editor/options/alerts';
import Join from './pages/join';
import useStore from './utils/useStore';

function App() {
  const token = localStorage.getItem('xand_user')

  const httpLink = new HttpLink({
    // uri: 'http://localhost:4003/graphql',
    uri: 'https://xand.backgen.io/graphql',
    headers: {
      Authorization: token || '',
    }
  });

  const wsLink = new GraphQLWsLink(createClient({
    // url: `ws://localhost:4003/graphql`,
    url: `wss://xand.backgen.io/graphql`
  }));

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    httpLink,
  );

  const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache()
  });

  return (
    <ApolloProvider client={client}>
      <Router>
        <AuthProvider>
          <div className="App">
            <SideBar />
            <div className='App_Body'>
              <Header />
              <Routing />
            </div>
            <Toaster position='bottom-center' />
            <AlertContainer />
          </div>
        </AuthProvider>
      </Router>
    </ApolloProvider>
  );
}

function Routing() {
  const setSelect = useStore((state) => state.setSelect)
  const location = useLocation()
  const { user } = useAuth()

  useEffect(() => {
    if (location.pathname === '/') {
      document.title = 'Home | XAND'
    } else {
      document.title = 'XAND'
    }
    setSelect(0)
  }, [location])

  if (user === 'No Auth') {
    return (
      <Routes>
        <Route path='*' element={<Navigate to={'/login'} />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/join/:id' element={<Join />} />
      </Routes>
    )
  } else if (user) {
    return (
      <Routes>
        <Route path='*' element={<Navigate to={'/'} />} />
        <Route path='/' element={<Home />} />
        <Route path='/join/:id' element={<Join />} />
        <Route path='/presentation/:id' element={<Presentation />} />
        <Route path='/games' element={<Games />} />
        <Route path='/the-quiz-game' element={<Quiz />} />
      </Routes>
    )
  } else {
    return (
      <div className='App_Loading'>
        XAND
      </div>
    )
  }
}

export default App;


// const elements = [{type:"Text", value:"Hello World", style:{fontSize:20}, position:{x:10, y:20}},{type:"Image", value:"https://demo.com/img.png", style:{height:100, width:200}, position:{x:10, y:20}}]